import { Router } from '@angular/router';
import { NotificationService, NotificationItem } from './../../../../services/notification-service/notification.service';
import { Component, OnInit, OnDestroy, inject, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MibpLogger, LogService, ScrollToService } from 'root/services';

import { ResourceStringComponent } from 'root/shared/components/localization/resource-string/resource-string.component';
import { MibpDateTimeComponent } from 'root/shared/components/formatting/datetime/datetime.component';



@Component({
  selector: 'mibp-dashboard-myactivity',
  templateUrl: './dashboard-tile-myactivity.component.html',
  styleUrls: ['./dashboard-tile-myactivity.component.scss', '../../modules/dashboard/pages/temporary-tiles.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ResourceStringComponent, MibpDateTimeComponent]
})
export class DashboardTileMyActivityComponent implements OnInit, OnDestroy {
  notificationService = inject(NotificationService);
  private router = inject(Router);
  private scrollToService = inject(ScrollToService);

  notificationSubscription: Subscription;
  hasUnreadNotifications = false;
  notifications: NotificationItem[] = [];
  log: MibpLogger;

  constructor() {
    const logger = inject(LogService);

    this.log = logger.withPrefix('dashboard-tile-myactivity');
    // Bind formatting function so we can access the component using "this"
    this.formatNotificationText = this.formatNotificationText.bind(this);
  }

  ngOnInit() {
    this.notificationSubscription = this.notificationService.notificationItems$.subscribe(event => {
      this.notifications.length = 0;
      if (event.length > 0) {
        this.hasUnreadNotifications = true;
      }

      event.forEach(n => {
        this.notifications.push(n);
      });
    });
  }

  formatNotificationText(translatedText: string, macros: Record<string, string>) {
    return this.notificationService.insertArgumentsIntoText(translatedText, macros.args);
  }

  showAll() {
    this.router.navigateByUrl(`/user/activity`).then(() => {
      this.scrollToService.scrollToTop();
    });
  }

  ngOnDestroy() {
    if (this.notificationSubscription) {
      this.notificationSubscription.unsubscribe();
    }
  }
}
